import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import Layout from './components/Layout';
import ShipmentPage from './pages/ShipmentPage';
import AddressBookPage from './pages/AddressBookPage';
import BulkShipPage from './pages/BulkShipPage';
import OrderHistoryPage from './pages/OrderHistoryPage';
import SettingsPage from './pages/SettingsPage';
import PrintPage from './pages/PrintPage';
import ApiConfigGate from './components/ApiConfigGate';

const router = createBrowserRouter([
  {
    path: '/print',
    element: <ApiConfigGate><PrintPage /></ApiConfigGate>,
  },
  {
    path: '/',
    element: <ApiConfigGate><Layout /></ApiConfigGate>,
    children: [
      { index: true, element: <ShipmentPage /> },
      { path: 'addresses', element: <AddressBookPage /> },
      { path: 'bulk-ship', element: <BulkShipPage /> },
      { path: 'orders', element: <OrderHistoryPage /> },
      { path: 'settings', element: <SettingsPage /> },
    ],
  },
]);

function App() {
  return <RouterProvider router={router} />;
}

export default App;
